import React from 'react'
import { useSelector } from 'react-redux'
import { Carousel } from 'react-bootstrap';

const Partners = () => {
    const partners = useSelector(state => state.partners.payload);
    let i = 0;
  return (
    <div className='row py-5'>
    <div className='row  justify-content-center'
    id='skills'
    >
        <p className='small-header mt-2 text-center'> <u>SKILLS</u>  </p>
        <Carousel variant='dark'
        indicators={false}
        controls = {false}
            className='eventSlider row mt-2 col-lg-2 col-md-3 col-sm-4 col-xs-6 col-4'
            
            >
            {
                partners.map((partner, index) => (
                
                <Carousel.Item key={index}
                className='col-lg-3 col-md-3 col-sm-6 col-xs-12'
                variant='dark'
                
                >
                   <div className='d-flex justify-content-center text-center align-items-center' 
                    style={{ 
                        
                    // color: 'white',
                    padding: '5px'
                    }}>
                <span className='text-center d-flex justify-content-center text-center align-items-center skills'
                          style={{ 
                            
                           }}
                          > 
                          {/* {
                        partner.image && 
                        <img src={partner.image} width={'150px'} height={'150px'} 
                          style={{ 
                            borderRadius: '10%'
                           }}
                          />
                      } */}
                      {partner.img}
                </span>
                </div>
                </Carousel.Item>
                ))
            }
        
        </Carousel>

         <Carousel variant='dark'
        indicators={false}
        controls = {false}
            className='eventSlider row mt-2 col-lg-2 col-md-3 col-sm-4 col-xs-6 col-4'
            
            >
            {
                partners.map((partner, index) => {
                  // let i = Number(index) + 1;
                  
                  if(partners.length <= index + 1){
                    i = 0
                  }else{
                    i = index + 1
                  }
                  // if(index == 0){
                  //   i = 1
                  // }else if(index == 1){
                  //   i = 2
                  // }


                  console.log(i);
                  return (
                
                    <Carousel.Item key={index}
                className='col-lg-3 col-md-3 col-sm-6 col-xs-12'
                variant='dark'
                
                >
                    {/* <span className='col-4'> */}
                    <div className='d-flex justify-content-center text-center align-items-center' 
                    style={{ 
                        
                    // color: 'white',
                    padding: '5px'
                    }}>
                <span className='text-center d-flex justify-content-center text-center align-items-center skills'
                          style={{ 
                           }}
                          > 
                      {/* <img src={partners[i].img} width={'150px'} height={'150px'} 
                          style={{ 
                            borderRadius: '100%'
                           }}
                          /> */}
                          {partners[i].img}
                </span>
                {/* <h3> {partners[i].title} </h3> */}
                </div>
                    
                      
                    </Carousel.Item>
                    )
                })
            }
        
        </Carousel>

         <Carousel variant='dark'
        indicators={false}
        controls = {false}
            className='eventSlider row mt-2 col-lg-2 col-md-3 col-sm-4 col-xs-6 col-4'
            
            >
            {
                partners.map((partner, index) => {
                  // let i = Number(index) + 1;
                  
                  if(partners.length <= index + 2){
                    i = 1
                  }else{
                    i = index + 2
                  }
                  console.log(i);
                  return (
                
                    <Carousel.Item key={index}
                className='col-lg-3 col-md-3 col-sm-6 col-xs-12'
                variant='dark'
                
                >
                   <div className='d-flex justify-content-center text-center align-items-center' 
                    style={{ 
                        
                    // color: 'white',
                    padding: '5px'
                    }}>
                <span className='text-center  d-flex justify-content-center text-center align-items-center skills'
                          style={{ 
                            
                           }}
                          > 
                      {/* {
                        partners[i].image && 
                        <img src={partners[i].image} width={'150px'} height={'150px'} 
                          style={{ 
                            borderRadius: '10%'
                           }}
                          />
                      } */}
                          {partners[i].img}
                </span>
                {/* <h3> {partners[i].title} </h3> */}
                </div>
                    
                    </Carousel.Item>
                    )
                })
            }
        
        </Carousel>
        <Carousel variant='dark'
        indicators={false}
        controls = {false}
            className='eventSlider row mt-2 col-lg-2 col-md-3 col-sm-4 col-xs-6 col-4'
            
            >
            {
                partners.map((partner, index) => {
                  // let i = Number(index) + 1;
                  
                  if(partners.length <= index + 3){
                    i = 2
                  }else{
                    i = index + 3
                  }
                  console.log(i);
                  return (
                
                    <Carousel.Item key={index}
                className='col-lg-3 col-md-3 col-sm-6 col-xs-12'
                variant='dark'
                
                >
                   <div className='d-flex justify-content-center text-center align-items-center' 
                    style={{ 
                        
                    // color: 'white',
                    padding: '5px'
                    }}>
                <span className='text-center  d-flex justify-content-center text-center align-items-center skills'
                          style={{ 
                           }}
                          > 
                      {/* <img src={partners[i].img} width={'150px'} height={'150px'} 
                          style={{ 
                            borderRadius: '100%'
                           }}
                          /> */}
                          {partners[i].img}
                </span>
                {/* <h3> {partners[i].title} </h3> */}
                </div>
                    
                    </Carousel.Item>
                    )
                })
            }
        
        </Carousel>
        <Carousel variant='dark'
        indicators={false}
        controls = {false}
            className='eventSlider row mt-2 col-lg-2 col-md-3 col-sm-4 col-xs-6 col-4'
            
            >
            {
                partners.map((partner, index) => {
                  // let i = Number(index) + 1;
                  
                  if(partners.length <= index + 4){
                    i = 3
                  }else{
                    i = index + 4
                  }
                  console.log(i);
                  return (
                
                    <Carousel.Item key={index}
                className='col-lg-3 col-md-3 col-sm-6 col-xs-12'
                variant='dark'
                
                >
                   <div className='d-flex justify-content-center text-center align-items-center' 
                    style={{ 
                        
                    // color: 'white',
                    padding: '5px'
                    }}>
                <span className='text-center  d-flex justify-content-center text-center align-items-center skills'
                          style={{ 
                           }}
                          > 
                      {/* <img src={partners[i].img} width={'150px'} height={'150px'} 
                          style={{ 
                            borderRadius: '100%'
                           }}
                          /> */}
                          {partners[i].img}
                </span>
                {/* <h3> {partners[i].title} </h3> */}
                </div>
                    
                    </Carousel.Item>
                    )
                })
            }
        
        </Carousel>
        <Carousel variant='dark'
        indicators={false}
        controls = {false}
            className='eventSlider row mt-2 col-lg-2 col-md-3 col-sm-4 col-xs-6 col-4'
            
            >
            {
                partners.map((partner, index) => {
                  // let i = Number(index) + 1;
                  
                  if(partners.length <= index + 5){
                    i = 4
                  }else{
                    i = index + 5
                  }
                  console.log(i);
                  return (
                
                    <Carousel.Item key={index}
                className='col-lg-3 col-md-3 col-sm-6 col-xs-12'
                // variant='dark'
                
                >
                   <div className=' skills d-flex justify-content-center text-center align-items-center' 
                    style={{ 
                    
                    // color: 'white',
                    padding: '5px'
                    }}>
                {/* <span className='text-center  d-flex justify-content-center text-center align-items-center skills'
                          style={{ 
                           }}
                          >  */}
                      {/* <img src={partners[i].img} width={'150px'} height={'150px'} 
                          style={{ 
                            borderRadius: '100%'
                           }}
                          /> */}
                          {partners[i].img}
                {/* </span> */}
                {/* <h3> {partners[i].title} </h3> */}
                </div>
                    
                    </Carousel.Item>
                    )
                })
            }
        
        </Carousel>
        


    </div>
    {/* <hr /> */}
    <div className='container mt-4 ms-2'>
        <h2 className='text-center'>LIST OF SKILLS AND PROFICIENCY</h2>
        <div className='row justify-content-space-evenly'>
            <div className='col-lg-6 col-md-6 col-12 '
            style={{ borderRightStyle:'groove' }}
            >
              <h3> FRONT-END</h3>
              <p className='skillList'> 
                  HTML(100%) | CSS(97%) | Javascript(98%) | JQuery(95%) | TypeScript(90%) | Vuejs(95%) | reactjs(97%) | Nextjs(95%)
                  React Native(97%) | Native Base(97%) | Bootstrap(98%) | Tailwind CSS(95%) | MUI CSS(93%)
              </p>
            </div>
            <div className='col-lg-6 col-md-6 col-12 '>
              <h3> BACK-END </h3>
              <p className='skillList'>
                  PHP(97%) |
                  NODEJS(95%) |
                  EXPRESSJS(90%) |
                  NEXTJS(96%) |
                  LARAVEL(93%)
              </p>
            </div>
        </div>
    </div>
    </div>
  )
}

export default Partners